module.exports = __webpack_public_path__ + "img/ic_radio_selected.66990569.png";